import React from 'react'
import PropTypes from 'prop-types'
import { LinearProgress } from '@mui/material'

const ProgressBar = ({ value, color, style }) => {
    return (
        <LinearProgress
            variant="determinate"
            value={value}
            sx={{
                color: color,
                backgroundColor: 'transparent',
                pt: 1,
                '.MuiLinearProgress-bar': {
                    backgroundColor: color
                },
                ...style
            }}
        />
    )
}

ProgressBar.propTypes = {
    value: PropTypes.number,
    color: PropTypes.string,
    style: PropTypes.object
}

export default ProgressBar
